<template>
  <div class="alpha-component-box alpha-component-box-content" style="padding: 10px;height:auto;flex:auto">
    <div class="remark-content">
      <div v-if="showRemarks.length" class="remarks-box" :style="`height: ${height}`">
        <div
          v-for="(item, index) in showRemarks"
          :key="index"
          :class="item && item.user === user ? 'remark-self' : ''"
        >
          <span class="remark-date">
            {{ dateFormat(item.createdAt) }} <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span>
            {{ item.user }}
            <template v-if="item.feedbackType">
              <span> 反馈了【{{ item.feedbackType }}】</span>
            </template>
            <template v-else>
              【{{ item.remarkType }}】<span v-if="item.职能模块">【{{ item.职能模块 }}】</span>
            </template>
            <i v-if="isAdmin || item.user===user" class="el-icon-delete ml10" style="flex:none;color:#de5c65;cursor:pointer;" @click="removeCompanyRemark(item)"></i>
          </span>
          <pre class="remark-info pd-10" style="text-indent:0">{{ item.content }}</pre>
        </div>
      </div>
      <div v-else class="remarks-box">
        <p>暂无反馈</p>
      </div>
        <!-- layout="prev, pager, next" -->
      <el-pagination
        layout="pager"
        :hide-on-single-page="true"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    height: { type: String, default: '400px' },
    cid: { type: String, default: '' },
    feedbackType: { type: String, default: '' },
  },
  data() {
    return {
      inputType:'客户经理', // 客户经理还是顾问类型
      inputValue: '',
      companyRemarks: [],
      projectFeedbacks: [],
      visitRecords: [],
      companyCognitive: [],
      categoryCognitive: [],
      salaryCognitive: [],
      page:1,
      // pageSize: 10,
      pageSize: 5,
      user:'',
      onlyThisUser:false,
      isAdmin: false,
    }
  },
  computed: {
    allRemarks() {
      const arr = window._.cloneDeep(this.companyRemarks)
      arr.sort((a,b)=>b.createdAt - a.createdAt)
      return arr
    },
    filterRemarks(){
      const { onlyThisUser, user, allRemarks } = this

      return allRemarks.filter(v=>{
        const isThisUser = v.user === user
        return (onlyThisUser?isThisUser:true)
      })
    },
    showRemarks(){
      const { filterRemarks, page, pageSize } = this
      return filterRemarks.slice((page-1)*pageSize,page*pageSize)
    },
    total(){
      return this.filterRemarks.length
    },
  },
  // watch: {
  //   inputType:{
  //     handler(newValue, oldValue) {
  //       if(newValue && this.cid) this.loadData()
  //     },
  //     immediate:true,
  //   },
  // },
  async mounted(){
    this.user = app.user.account
  },
  methods: {
    pageChange(page){
      this.page = page
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    async loadData(){
      if(this.inputType==='客户经理') this.getCompanyRemark()
    },
    async getCompanyRemark() {
      const option = { cid: this.cid }

      const res = await app.service('company').newGetCompanyRemark(option)
      if (res.status === 'success') {
        const companyRemarks = []
        ;(res.data||[]).forEach(v=>{
          const arr = (v.remark) || []
          arr.forEach(b=>{
            b.remarkType='沟通备注'
          })
          companyRemarks.push(...arr)
        })

        companyRemarks.sort((a, b) => b.createdAt - a.createdAt)
        this.companyRemarks = companyRemarks.filter(a=>a.feedbackType === this.feedbackType)
        this.page = 1
      } else this.$message.error(res.msg)
    },
    removeRemark(remark){
      if(remark.remarkType==='沟通备注'){
        this.removeCompanyRemark(remark)
      }
    },
    async removeCompanyRemark(remark){
      this.$confirm('确定要移除这条日志吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await app.service('company').removeCompanyRemark({
          cid: this.cid,
          remark: remark,
        })
        if (res.status === 'success') {
          this.$message.success('删除成功')
          this.getCompanyRemark()
        }else this.$message.error(res.msg)
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
  },
}
</script>
<style src="../../../statistics/css/common.css" scoped></style>
<style scoped>
.remark-content{
  flex:auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.remarks-box{
  flex:auto;
  padding-top:10px;
  overflow: auto;
}
.remark-info{
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
